import React, { useEffect, useState } from 'react';
import { FaExternalLinkAlt, FaWrench } from "react-icons/fa";
import { IoMdRefresh } from "react-icons/io";
import Moment from 'react-moment';
import { useOutletContext } from 'react-router-dom';
import colors from '../../config/colors.json'
import { timeFromNow } from '../../helpers/timeFromNow';
import { useSocketState } from '../../helpers/useSocket';

function PostGameDashboard() {
    const { socket, refreshGames } = useOutletContext()

    const [filter, setFilter] = useState("");

    const [games, setGames] = useState({ list: [] });
    const [preview, setPreview] = useState({});

    const [match] = useSocketState('Match');

    useEffect(() => {
        socket.emit('registerPostgame')

        function onUpdatePreview(value) {
            console.log(`Received updatePreview`, value);
            setPreview(oldState => ({ ...oldState, ...value }));
        }

        function onUpdateGames(value) {
            console.log(`Received updateGames`, value);
            setGames(oldState => ({ ...oldState, ...value }));
        }

        socket.on('updateGames', onUpdateGames);
        socket.on('updatePreview', onUpdatePreview);

        return () => {
            socket.off('updateGames', onUpdateGames);
            socket.off('updatePreview', onUpdatePreview);
        }

    }, []);

    function modifyLeftPlayer(data) {
        socket.emit('modifyLeftPlayer', { ...match.leftPlayer, ...data });
    }

    function modifyRightPlayer(data) {
        socket.emit('modifyRightPlayer', { ...match.rightPlayer, ...data });
    }

    function updateExtra(data) {
        socket.emit('setPreviewExtra', { ...preview?.extra, ...data });
    }

    function updateGame(game_id) {
        console.log(`Updating game ${game_id}`);

        socket.emit('updateGame', game_id);
    }

    function selectGameSummary(game_id) {
        console.log(`Selecting game summary ${game_id}`);

        socket.emit('selectGame', game_id);
    }

    function showSelected() {
        socket.emit('showSelected');
    }

    function hideSelected() {
        socket.emit('hideSelected');
    }

    function getCustomGame() {
        console.log("Get Custom Game")
        socket.emit('selectGame', 267933);
    }

    return (
        <>
            {
                preview?.extra &&
                <div className='mt-8 flex flex-row upper'>
                    <div>

                        <div className='text-2xl font-bold mb-2'>Prepare</div>
                        <div>
                            <span className='mr-10'>Game</span>
                            <span>{preview.game_id}</span>
                            {
                                (preview.fetching) ?
                                    <span className='pl-4'><div className="lds-ring mr-2"><div></div><div></div><div></div><div></div></div>(Summary Pending)</span>
                                    : preview.game_id && !preview.summary && <span className='pl-4'>(Summary Failed)</span>
                            }
                        </div>
                        <div className='my-4'>
                            <label>Left Player <span className='text-sm text-gray-500 ml-5'>(This players stays left, auto adjusts for new players)</span></label>
                            <input className='w-[150px]' type="text" value={match?.leftPlayer.name} onChange={(e) => modifyLeftPlayer({ name: e.target.value })} id="leftPlayer" name="leftPlayer" />
                        </div>
                        <div className='grid grid-cols-2 gap-y-4 w-[250px]'>
                            <div className='w-24'>
                                <label>Left Relics</label>
                                <input type="number" value={preview.extra.leftRelics} onChange={(e) => updateExtra({ leftRelics: Number(e.target.value) })} id="leftRelics" min="0" name="leftRelics" />
                            </div>
                            <div className='w-24'>
                                <label>Right Relics</label>
                                <input type="number" value={preview.extra.rightRelics} onChange={(e) => updateExtra({ rightRelics: Number(e.target.value) })} id="rightRelics" min="0" name="rightRelics" />
                            </div>
                        </div>
                        <div className='mt-4'>
                            <button onClick={showSelected} disabled={!preview.summary} className='max-w-16'>Show</button> <button className='max-w-16' onClick={hideSelected}>Hide</button>
                        </div>

                    </div>
                    <div>
                            <iframe src="/" className='w-[1920px] h-[1080px] ml-20 bg-black' style={{zoom: 0.2}}>

                            </iframe>
                    </div>
                </div>
            }
            {games?.list &&
                <div className='mt-8 lower'>
                    <div className='mb-2'>
                        <div className='flex flex-row'>

                            <span className='text-2xl font-bold mr-10'>Games</span>
                            <button onClick={() => refreshGames()}>Refresh Games</button>{(games.fetching || games.updating) && <div className="lds-ring"><div></div><div></div><div></div><div></div></div>}

                            <input key="filter" className="ml-10 w-64 mr-4" onChange={(e) => setFilter(e.target.value)} value={filter} placeholder="Filter (map or player name)" />
                            <button key="reset-filter" onClick={() => setFilter("")}>Clear</button>
                        </div>
                        <div className='flex flex-row'>
                            <div className='align-bottom flex flex-col'>
                                <button onClick={() => getCustomGame()}>Get Custom Game</button>
                            </div>
                        </div>
                    </div>
                    <div>
                        {
                            games.list.filter(g => {
                                if (!filter || filter.trim() === "") return true;
                                try {
                                    const mapMatches = g.map.toLowerCase().includes(filter.toLowerCase());
                                    const playerMatches = g.teams.some(team =>
                                        team.some(player =>
                                            player.player.name.toLowerCase().includes(filter.toLowerCase())
                                        )
                                    );
                                    return mapMatches || playerMatches;
                                } catch (e) {
                                    console.error("Error during filtering", e);
                                    return true;
                                }
                            }).map(game =>
                                <div className="flex border-y py-2" id={game.game_id}>
                                    {game.ongoing && console.log(game)}
                                    <div>
                                        <div className=''><span className='font-bold'>Game ID: </span> {game.game_id}<a href={`https://aoe4world.com${game.summary_site_url}`} target='_blank'><FaExternalLinkAlt className='ml-1 mt-1' /></a></div>
                                        <div className=''><span className='font-bold'>Map: </span>{(game.map).includes("Crafted Map") && <FaWrench className='mx-1 mt-1' />} {(game.map).replace("Crafted Map", "").replace("(", "").replace(")", "")}</div>
                                        <div>Started at: <Moment format='HH:mm - DD MMM YYYY' date={game.started_at} /></div>
                                        {
                                            (game.ongoing || game.just_finished) ?
                                                <div><span className='font-bold'>State: </span>{game.ongoing ? `InGame ${timeFromNow(game.started_at)} - Delay: ${game.observer_delay}` : game.just_finished ? 'Just Finished' : 'Processed'}</div>
                                                :
                                                <div>Duration: {(game.duration / 60).toFixed(0)} min</div>
                                        }
                                    </div>
                                    <div className='players pl-8 my-auto'>
                                        {
                                            game.teams.map((team, i) =>
                                                <div className="team">
                                                    {
                                                        team.map((player, i) =>
                                                            <div className="player flex gap-2 p-1">
                                                                <div className='w-10'>{player.player.result}</div>
                                                                <img className={`w-10 h-full aspect-auto right-0 object-cover mr-2`} src={`/civFlags/${player.player.civilization}.png`} alt="Civ" />
                                                                <div>{player.player.name}</div>
                                                                <a href={`https://aoe4world.com/players/${player.player.profile_id}`} target='_blank'><FaExternalLinkAlt className='mt-1' /></a>
                                                            </div>
                                                        )
                                                    }

                                                    {i == 0 && <hr />}
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className='ml-8 my-auto'>
                                        {
                                            (game.ongoing || game.just_finished) ?
                                                <button onClick={() => updateGame(game.game_id)}>Update</button>
                                                :
                                                <><button onClick={() => selectGameSummary(game.game_id)}>Select</button><button className="bg-transparent hover:bg-transparent text-black text-2xl absolute" onClick={() => updateGame(game.game_id)}><IoMdRefresh /></button></>
                                        }
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            }
        </>
    )
}

export default PostGameDashboard;
